import { defineChannel, type ChannelDefinition } from '../channel-definition';

export const lineChannel = defineChannel({
  id: 'line',
  icon: 'brand/line',
} as const satisfies ChannelDefinition);
